import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezone from 'dayjs/plugin/timezone';
import * as duration from 'dayjs/plugin/duration';
import * as isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import * as isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import * as customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(customParseFormat);
import * as isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isBetween);

import { enableProdMode, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { storageFactory, options, configFactory } from './app/app.module';
import { environment } from './environments/environment';
import { StationService } from './app/services/station/station.service';
import { DataService } from './app/services/dataService/data-service.service';
import { QuickSearchService } from './app/services/quick-search/quick-search.service';
import { RoleSelectionService } from './app/services/role-selection/role-selection.service';
import { AlertSeverityPipe } from './app/pipes/alert-severity.pipe';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';
import { TokenInterceptor } from './app/interceptors/token.interceptor';
import { OAuthStorage, OAuthModule } from 'angular-oauth2-oidc';
import { provideNgxMask, NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule as EmtCommonModule } from 'projects/common/src/public_api';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { ConfigModule, ConfigLoader, ConfigHttpLoader } from './app/services/config/config';
import { StoreModule } from '@ngrx/store';
import { reducers, metaReducers } from './app/store';
import { EffectsModule } from '@ngrx/effects';
import { StationsEffects } from './app/store/effects/station/station.effects';
import { AlertEffects } from './app/store/effects/alert/alert.effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(AppRoutingModule, HttpClientModule, MatMomentDateModule, BrowserModule, FormsModule, ReactiveFormsModule, EmtCommonModule, ConfigModule.forRoot({
            provide: ConfigLoader,
            useFactory: configFactory,
            deps: [HttpClient],
        }), StoreModule.forRoot(reducers, { metaReducers }), EffectsModule.forRoot([StationsEffects, AlertEffects]), StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: environment.production,
        }), NgbDatepickerModule, NgxMaskDirective, NgxMaskPipe, OAuthModule.forRoot()),
        StationService,
        DataService,
        QuickSearchService,
        RoleSelectionService,
        AlertSeverityPipe,
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: { dateInput: 'DDMMMYYYY' },
                display: {
                    dateInput: 'DDMMMYYYY',
                    monthYearLabel: 'MMM YYYY',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'MMMM YYYY',
                    parse: {
                        dateInput: 'DDMMYYYY',
                    },
                },
            },
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true,
        },
        { provide: OAuthStorage, useFactory: storageFactory },
        provideNgxMask(options),
        provideAnimations(),
        provideCharts(withDefaultRegisterables()),
    ]
})
  .catch(err => console.error(err));
